import React from 'react';
import { array } from 'prop-types';
import { map, filter, includes, isEmpty } from 'lodash';
import { FormikSelect, Loading } from '../../common';
import GetABMGroups from '../../graphql/getABMGroups';

const FormikInputABMGroups = ({ filterGroups, ...props }) => {
    return (
        <GetABMGroups>
            {({ data, loading }) => (
                <Loading loading={loading}>
                    <FormikSelect
                        {...props}
                        showArrow
                        mode='multiple'
                        optionFilterProp='alias'
                        options={map(
                            isEmpty(filterGroups) ? data : filter(data, ({ alias }) => includes(filterGroups, alias)),
                            ({ id, alias }) => ({ value: id, label: alias })
                        )}
                    />
                </Loading>

            )}
        </GetABMGroups>
    );
};

FormikInputABMGroups.propTypes = {
    filterGroups: array
};

export default FormikInputABMGroups;
